import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_CUSAT_IMPORT } from 'constants/api';
import { storeName } from '../config';
import { CusatImportError, CusatImportResult } from '../interfaces';

export const importCusat = createAsyncThunk<
  CusatImportResult,
  File,
  { rejectValue: CusatImportError }
>(`${storeName}/import`, async (file, thunkAPI) => {
  const formData = new FormData();
  formData.append('file', file, file.name);

  return api.axios
    .post(API_CUSAT_IMPORT, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((res) => res.data)
    .catch((e) =>
      // The page renders the row errors itself, so the generic error toast is suppressed.
      thunkAPI.rejectWithValue({
        message: e.response?.data?.message || e.message || 'unknown',
        error: e.response?.data?.error,
        errors: e.response?.data?.errors,
        ignoreErrorHandlingMiddleware: true,
      }),
    );
});
